import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { productPath } from "@travily/routes";
import type ListingsEditorShow from "@travily/types/pages/ListingsEditorShow";
import type { ReactNode } from "react";
import { EditFrame } from "@/layouts/edit-frame";
import PersistentLayout from "@/layouts/persistent-layout";
import { buildEditorSections } from "@/lib/editor-sections";
import { ProductEditorSectionsView } from "./show.view";

const ProductEditIndexPage = (props: ListingsEditorShow) => {
  const sections = buildEditorSections(props);
  const title = t("web.products.editors.show.title");

  return (
    <EditFrame
      backHref={productPath(props.listing_id)}
      href={productPath(props.listing_id)}
      sections={sections}
      title={title}
    >
      <Head title={t("web.products.editors.show.meta_title", { title: props.listing_title ?? "" })} />
      <ProductEditorSectionsView sections={sections} title={title} />
    </EditFrame>
  );
};

ProductEditIndexPage.layout = (page: ReactNode) => <PersistentLayout>{page}</PersistentLayout>;

export default ProductEditIndexPage;
